export const MODULE_COMPARATIVE_ROUTE_NAME = 'school.module.comparative';
export const MODULE_SCORE_COMPARATIVE_ROUTE_NAME = 'school.module.score';
export const MODULE_TIME_COMPARATIVE_ROUTE_NAME = 'school.module.time';
export const GROUP_MANAGE_STUDENTS_ROUTE_NAME = "school.group.add-student";
export const GROUP_MANAGE_TEACHERS_ROUTE_NAME = "school.class.register-teacher-class";
export const HOME_ROUTE_NAME = "school.home";
export const GROUPS_ROUTE_NAME = "school.group.index";
export const DOWNLOAD_ROUTE_NAME = "school.file.index";
export const STUDENT_MODULE_PROGRESS_ROUTE_NAME = "school.student.progress";
export const STUDENT_PRESENCE_ROUTE_NAME = "school.student.presence";
export const STUDENT_TRAIL_ROUTE_NAME = "school.student.trails";
export const GRADE_ANALYSIS_ROUTE_NAME = "school.student.cycle.challenge.performance";
export const CONFIGS_CYCLE_ROUTE_NAME = "school.configs.cycle";
export const CONFIGS_TRAIL_ROUTE_NAME = "school.configs.trail";
export const TEACHERS_ROUTE_NAME = "school.manager.index";
export const STUDENT_ROUTE_NAME = "school.student.index";
export const CHALLENGE_APPLICATION_PERIOD_ROUTE_NAME = "school.challenge.application.period.index";
export const BOOKS_AND_CARDS_ROUTE_NAME = "school.books.and.cards.index";
export const CARD_UPLOADS_ROUTE_NAME = "school.card.uploads.index";
export const USER_CONFIG_ROUTE_NAME = "school.user.config";
export const CONFIG_MODULE_PERIOD_ROUTE_NAME = "school.module.period.config";
export const MODULES_QUANTITY_ROUTE_NAME = "school.module.qty.config";
export const MODULES_BLOCK_ROUTE_NAME = "school.module.block.config";
export const SCORE_CALC_ROUTE_NAME = 'school.calc-score';
export const PRE_DASHBOARD_ROUTE_NAME = 'school.pre-dashboard';
export const PAGE_NOT_FOUND = "page.not.found";

export const EMPLOYEE_ROUTES = [
  DOWNLOAD_ROUTE_NAME,
  HOME_ROUTE_NAME,
  PAGE_NOT_FOUND,
  BOOKS_AND_CARDS_ROUTE_NAME,
  CARD_UPLOADS_ROUTE_NAME,
  STUDENT_ROUTE_NAME,
  TEACHERS_ROUTE_NAME,
  PRE_DASHBOARD_ROUTE_NAME,
  

  //rotas de análise de módulos
  MODULE_TIME_COMPARATIVE_ROUTE_NAME,
  STUDENT_PRESENCE_ROUTE_NAME,
  STUDENT_MODULE_PROGRESS_ROUTE_NAME,
  GRADE_ANALYSIS_ROUTE_NAME,
  MODULE_COMPARATIVE_ROUTE_NAME,
  MODULE_SCORE_COMPARATIVE_ROUTE_NAME,
  USER_CONFIG_ROUTE_NAME,
  SCORE_CALC_ROUTE_NAME,

]

export const MANAGER_ROUTES = [
  ...EMPLOYEE_ROUTES,
  // rotas de gerenciamento
  GROUP_MANAGE_TEACHERS_ROUTE_NAME,
  GROUP_MANAGE_STUDENTS_ROUTE_NAME,
  CONFIGS_TRAIL_ROUTE_NAME,
  STUDENT_TRAIL_ROUTE_NAME,
  CHALLENGE_APPLICATION_PERIOD_ROUTE_NAME,
  CONFIG_MODULE_PERIOD_ROUTE_NAME,
  MODULES_QUANTITY_ROUTE_NAME,
  MODULES_BLOCK_ROUTE_NAME
];

export const TEACHER_ROUTES = [
  ...EMPLOYEE_ROUTES
];






